/*
创建者 魏强(2018.1.24)
首页 限时特价
*/
<template>
	<div class="dundun-bargain">
		<xs-title :h="exp.h" :m="exp.m" :s="exp.s"></xs-title>
		<xs-list :list="list"></xs-list>
	</div>
</template>
<script>
import list from './list.vue';
import title from './title.vue';
export default {
	props:["data"],
	components:{
		"xs-title":title,
		"xs-list":list
	},
	data(){
		return {
			et:this.data.et,
			list:this.data.list,
			exp:{},
			timer:null
		}
	},
	created(){
		let endTime = this.et;
		let exp={};
		let totalSeconds = parseInt( (new Date(endTime)*1-Date.now() )/1000);
		let _h= parseInt((totalSeconds%(24*3600) )/3600);
		let _m= parseInt( (totalSeconds%3600)/60 );
		let _s= parseInt( totalSeconds%3600%60 );
		let s,m,h;
		this.timer = setInterval(()=>{
			if(--_s<0&&_m>=0){
				_s=59;
				if(--_m<0&&_h>0){
					_m=59;
					--_h;
				}
			}
			s= Math.max(_s,0);
			m= Math.max(_m,0);
			h= Math.max(_h,0);
			this.exp = {
				h,m,s
			};
			if(s==0 && m == 0 && h == 0){
				clearInterval(this.timer)
			}
		},1000);
	},
	destroyed(){
		clearInterval( this.timer );
	},
	methods:{
		getDuration(d){
			let ss = d;
			let h = (ss/60/60).toFixed()*1;
			ss = ss%(60*60);
			let m = (   ss/60   ).toFixed()*1;
			let s = ss%60;
			return {
				h,m,s
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// index.vue?474c9414